module.exports = __webpack_public_path__ + "static/media/photo246.bcd4b166.jpg";